module.exports = __webpack_public_path__ + "app/docrepo-invoice/detail/events-2qcoeYsU.html";